import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-72c2beaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alm-action-modal-body" }
const _hoisted_2 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_modal = _resolveComponent("f-modal")!

  return (_openBlock(), _createBlock(_component_f_modal, {
    visible: _ctx.isVisible,
    class: "alm-action-modal",
    title: `${_ctx.localizer.Localize('Delete_PascalCase')} ${_ctx.currentChangeset?.name ?? ''}`,
    "onUpdate:visible": _cache[1] || (_cache[1] = (vis) => _ctx.setVisible(vis))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_f_button, {
          text: "Button",
          type: "default",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize("Cancel_PascalCase")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_f_button, {
          text: "Button",
          type: "primary",
          danger: "",
          onClick: _ctx.confirmDelete
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localizer.Localize("Delete_PascalCase")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Changeset_Deletion_Modal_Text")), 1)
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}